import moment from 'moment';

export const dateFormat = date =>
  date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : null;

export const dateTimeFormat = date =>
  date ? moment.utc(date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY LT') : null;



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js